export default __webpack_public_path__ + "static/media/lady-phone.4bf6335a.png";